<!-- eslint-disable max-len -->
<template>
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4.5" width="24" height="18.6486" rx="3" stroke="currentColor" stroke-width="2" />
    <path d="M11 27H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    <path
      d="M13.4613 19.0045L13.4971 19.0045L13.5328 19.002C14.1816 18.9561 14.7634 18.6549 15.204 18.164L21.1124 12.2556C21.3613 12.0067 21.5011 11.6691 21.5011 11.3172C21.5011 10.9652 21.3613 10.6276 21.1124 10.3787L19.6249 8.89121C19.6243 8.89057 19.6236 8.88993 19.623 8.8893C19.3747 8.64011 19.0375 8.5 18.6856 8.5C18.3339 8.5 17.9966 8.64009 17.7484 8.88925L11.805 14.8307C11.3542 15.2407 11.0554 15.8164 11.0038 16.4031L11 16.4467L11 16.4906L11 18.0032L11 19.0023L11.9991 19.0032L13.4613 19.0045Z"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>
